import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';

import { CrmConfig, CurrencyConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { StringInterpolationPipe } from '@frontend/sports/common/core/utils/string-interpolation';
import { OddsFormatterService } from '@frontend/sports/odds/feature';
import { UserService } from '@frontend/sports/user/feature';
import { IntlService } from '@frontend/vanilla/core';
import { TokensSummaryService } from 'packages/sports/web/app/src/tokens-base/tokens-summary.service';

import { CurrencyPipe } from '../../../../../../base/pipes/currency.pipe';
import { FreeBetToken } from '../../../../reward-tokens.model';
import { RewardTokensBannerService, TokenCategories } from '../../../../services/reward-tokens-banner.service';
import { RewardTokenCardBaseComponent } from '../reward-token-card-base.component';
import { RewardTokenLimitation } from '../reward-token-limitations.component';

@Component({
    selector: 'bs-freebet-card',
    templateUrl: './freebet-card.component.html',
    styleUrls: ['../../cards/styles/reward-token-card-shared.scss', './freebet-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FreeBetCardComponent extends RewardTokenCardBaseComponent<FreeBetToken> implements OnInit {
    @HostBinding('class') className = 'freebet-card';
    override showPayout: boolean;
    @HostBinding('class.reward-drawer__details') get formCoupon(): boolean {
        return this.isRewardDrawerEnabled;
    }

    prependCurrencySymbol: boolean;
    fractionSize = 2;
    @Input() override isRewardDrawerEnabled: boolean;
    expireTokenReward: RewardTokenLimitation[];
    betType: RewardTokenLimitation[];
    promoHubUrlTokenType: string;
    tokenCategories: TokenCategories;
    tokenLimitations: RewardTokenLimitation[];
    isCustomTitle: boolean;
    payoutamountDetails = '';
    constructor(
        public override sitecore: Sitecore,
        protected override crmConfig: CrmConfig,
        protected override intlService: IntlService,
        public userService: UserService,
        private currencyConfig: CurrencyConfig,
        protected override oddsFormatterService: OddsFormatterService,
        protected override tokensPayoutInfo: TokensSummaryService,
        private interpolationPipe: StringInterpolationPipe,
        private currencyPipe: CurrencyPipe,
        private rewardTokensBannerService: RewardTokensBannerService,
    ) {
        super(sitecore, crmConfig, userService, intlService, oddsFormatterService, tokensPayoutInfo);
        this.prependCurrencySymbol = this.currencyConfig.currencySymbolDisplayList.includes(this.userService.currency);
    }

    get tokenTitle(): string {
        return this.token.customTitle ? this.token.customTitle : this.sitecore.crmTokens.messages.Freebet;
    }

    ngOnInit(): void {
        this.expireTokenReward = this.getTokenUserExpire();
        this.betType = this.getTokenBetType();
        this.tokenCategories = this.rewardTokensBannerService.getTokenCategories(this.token);
        this.tokenLimitations = this.getTokenLimitations();
        this.isCustomTitle = !!this.token.customTitle;
        this.payoutamountDetails = this.interpolationPipe.transform(this.sitecore.crmTokens.cards.ExcludingBonus, {
            amount: this.currencyPipe.transform(this.token.amount, true, 2, true, undefined, undefined, false),
        });
        this.promoHubUrlTokenType = this.sitecore.crmTokens.ctaLinks.promoCtaLinks.FreeBet;
    }
}
